import gql from 'graphql-tag';

export const queryData = gql`
   query DATA {
      presentaciones {
         codigo
         denominacion
      }
      productos {
         codigo
         denominacion
      }
      versiones {
         codigo
         denominacion
      }
      modulares {
         codigo
         codigoProducto
         denominacion
      }
   }
`;

export const queryDataVer = gql`
   query DATA($codigoProducto: String) {
      productoDetallesFiltro(codigoProducto: $codigoProducto) {
         version {
            codigo
            denominacion
         }
         presentacion {
            codigo
            denominacion
         }
      }
   }
`;
//agregar fecha de vigencia para apis
export const queryCodActivacion = gql`
   query CodActivacion($codigo: String!) {
      codigoActivacion(codigo: $codigo) {
         codigo
         producto
         presentacion
         version
         modular
         razonSocial
         ruc
         anio
         fechaExpiracion
         fechaVigenciaApi
         fechaVigenciaSoporte
         grupo
         tipoDoc
         serieDoc
         nroDoc
      }
   }
`;
//agregar fecha de vigencia para apis
export const mutationGenerarLicencia = gql`
   mutation GenerarLicencias(
      $ruc: String!
      $razonsocial: String!
      $tipoDoc: String!
      $serieDoc: String!
      $nroDoc: String!
      $usuario: String!
      $activaciones: [GenerarLicenciaInput]!
   ) {
      generarLicencia(
         ruc: $ruc
         razonsocial: $razonsocial
         tipoDoc: $tipoDoc
         serieDoc: $serieDoc
         nroDoc: $nroDoc
         usuario: $usuario
         activaciones: $activaciones
      ) {
         msg
      }
   }
`;
